import { PropsWithChildren } from 'react';
import AuthLayout from 'features/auth/AuthLayout';
import { ThemedDomainConfig } from 'libs/config';

export type DomainAuthLayoutProps = {
  domainConfig: ThemedDomainConfig;
} & PropsWithChildren;

// A wrapper that will extract info from domain configuration
// and pass it to general purpose AuthLayout
const DomainAuthLayout = ({
  domainConfig,
  children,
}: DomainAuthLayoutProps) => {
  return (
    <AuthLayout
      backgroundImageUrl={domainConfig.assets.authBg}
      theme={domainConfig.themes[1]}
    >
      {children}
    </AuthLayout>
  );
};

export default DomainAuthLayout;
